import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { IGetPermissionMandatoryField } from '../interface';
import { CommonMethodService } from 'src/app/Shared/common-method.service';
import { FingerPrintInitService } from 'src/app/services/fingerPrint/fingerPrintInit.service';
import { FingerprintpopupComponent } from '../fingerprintpopup/fingerprintpopup.component';
import { take } from 'rxjs/operators';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { UserSessionService } from 'src/app/services/usersession.service';

@Component({
    selector: 'app-add-notes-shared',
    templateUrl: './add-notes-shared.component.html',
    styleUrls: ['./add-notes-shared.component.scss'],
    standalone: false
})
export class AddNotesSharedComponent implements OnInit {

  @Input() unitsList;
  @Input() inquiryNumber;
  @Input() reservationNumber;
  @Input() LeaseNo;
  @Input() facilityId;
  @Input() transactionTypeId;
  @Output() isPriorityNotesSaved: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(FingerprintpopupComponent, { static: true }) FingerprintpopupComponent: FingerprintpopupComponent;
  miscellaneousSettings: any;
  fingerPrintInit: any;
  formNamenoteForm: any = 'noteForm';
  noteForm: FormGroup;
  loaderIcon: Promise<boolean>;
  componentName: any = 'faceops-customer-rental.component.html';
  today: string;
  unitId : any;
  public fieldsvalues: Object = {text: "UnitNumber", value: "UnitId" };

  mode :string;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };

  constructor(private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private userSessionService: UserSessionService,
    private prospectsService: ProspectService,
    private toaster: ToastrService,
    private commonMethod: CommonMethodService,
    public fingerPrintInitService: FingerPrintInitService,
    private customerDataService: CustomerDataService) { }

  ngOnInit() {
    this.mode = 'CheckBox';
    this.noteForm = this.formBuilder.group({
      Notes: ['', Validators.required],
      CustomerNotes: [''],
      PriorityNotes: [''],
      unitRented: ['', Validators.required],
      keepActiveDate: [],
      LinkedUnitId :[""]
    });
    const datepipe: DatePipe = new DatePipe('en');
    this.today = datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.noteForm.get("unitRented").patchValue(this.LeaseNo)
    this.customerDataService.miscellaneousSettingsDetails.subscribe((resp) => {
      this.miscellaneousSettings = resp;
      if (resp && resp.UserAuthenticationforNonFinancial) {
        this.fingerPrintInitService.Initialize(3);
      }
    });
  }

  setMandatoryField() {
    this.loaderIcon = Promise.resolve(true);
    this.generalService.GetMandatoryFields(this.facilityId, this.componentName, this.formNamenoteForm)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Name == this.componentName && data.Form.Name != undefined && data.Form.Name == this.formNamenoteForm) {
          if (data.Form.ListOfProperties.length != 0) {
            data.Form.ListOfProperties.forEach(field => {
              if (field.Required) {
                this.noteForm.get(field.Name).setValidators([Validators.required]);
                this.noteForm.updateValueAndValidity();
              }
            });
          }
        }
      })
    this.loaderIcon = Promise.resolve(false);
  }

  isRequirednoteForm(control) {
    if (this.noteForm.get(control).validator !== null) {
      const validator = this.noteForm.get(control).validator({} as AbstractControl);
      return validator && validator.required ? true : false;
    } else {
      return false
    }
  }

  Addprioirtynote(eve) {
    if (!eve.target.checked) {
      this.noteForm.get('keepActiveDate').setValue('');
    }
  }

  cancelNotes() {
    this.noteForm.reset();
    this.isPriorityNotesSaved.emit(false)
  }

  saveNotesAuthentication(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);
    if (this.miscellaneousSettings && this.miscellaneousSettings.UserAuthenticationforNonFinancial) {
      this.FingerprintpopupComponent.openFingerprintModal();
      this.fingerPrintInitService.startCapture();
      this.fingerPrintInitService.fingerPrintService.moduleType = 3;
      this.fingerPrintInitService.currrentModule = 3;
      this.fingerPrintInitService.emitCaptureEvent.pipe(take(1)).subscribe((resp) => {
        if (resp && resp.modType == 3) {
          if (resp && resp.caltureResponse && resp.caltureResponse.Success) {
            this.FingerprintpopupComponent.isFingerprintAcquired = true;
            this.FingerprintpopupComponent.initials = '';
            this.FingerprintpopupComponent.pin = '';
            this.FingerprintpopupComponent.fingerPrintAuthModal.hide();
            this.fingerPrintInitService.stopCapture();
            this.emitFingerPrintSuccess('');
          } else {
            this.FingerprintpopupComponent.isFingerprintAcquired = false;
            this.FingerprintpopupComponent.fingerprintMessage = resp.caltureResponse.Message;
          }
        }
      });
    } else {
      this.savePriorityNotes();
    }
  }

  emitFingerPrintSuccess(data) {
    this.savePriorityNotes();
  }

  cancelFingerPrint(data) {

  }

  savePriorityNotes() {
    let isCallCenterGroup = false;
    let selectedUnitFacilityId = 0;
    let rentUnitObj = this.unitsList.find(o => o.UnitId == this.noteForm.value.LinkedUnitId[0]);
    selectedUnitFacilityId = rentUnitObj?.FacilityID ?? this.facilityId;
    let selectedUnitNo = rentUnitObj.UnitNumber;

    if (this.inquiryNumber > 0) {
      if (rentUnitObj.ProcessType == 'Inquiry Unit') {
        this.inquiryNumber = rentUnitObj.ConfirmationNumber;
      }
    }

    if (this.reservationNumber > 0) {
      if (rentUnitObj.ProcessType == 'Reserved Unit') {
        this.reservationNumber = rentUnitObj.ConfirmationNumber;
      }
    }

    if (this.LeaseNo > 0) {
      if (rentUnitObj) {
        this.LeaseNo = rentUnitObj.LeaseNo;
      }
    }
    isCallCenterGroup = this.userSessionService?.isCallcenterAgent === true ? true : false;
    let notesObj = {
      NotesId: 0,
      LeaseNo: this.LeaseNo == 0 ? null : this.LeaseNo,
      FacilityId: selectedUnitFacilityId,
      ReservationNumber: this.reservationNumber == 0 ? null : this.reservationNumber,
      ReservationFacilityId: this.reservationNumber == 0 ? null : selectedUnitFacilityId,
      InquiryNumber: this.inquiryNumber == 0 ? null : this.inquiryNumber,
      InquiryFacilityId: this.inquiryNumber == 0 ? null : selectedUnitFacilityId,
      InquiryNotesFacilityId: null,
      FollowUpId: null,
      NotesDate: new Date(),
      Text: this.noteForm.value.Notes,
      CustomerNotes: false,
      PriorityNote: this.noteForm.value.PriorityNotes,
      CollectionCall: false,
      PaymentReceiptId: null,
      DisplayAlert: isCallCenterGroup,
      UnitNo: selectedUnitNo,
      TransactionTypeId: this.transactionTypeId,
      Creator: null,
      PriorityId: 0,
      PriorityNoteExpiry: this.commonMethod.getDateTimeWithoutTimeForApi(this.noteForm.value.keepActiveDate),
      LinkedUnitLeaseNoList : this.mapLinkedUnitNotes(this.noteForm.value.LinkedUnitId),
      TenantId : this.unitsList[0].TenantId
    }
    this.saveNotesAPI(notesObj)
    
    if (this.noteForm.value.CustomerNotes.trim()!="") {
      let notesObj1 = {
        NotesId: 0,
        LeaseNo: this.LeaseNo == 0 ? null : this.LeaseNo,
        FacilityId: selectedUnitFacilityId,
        ReservationNumber: this.reservationNumber == 0 ? null : this.reservationNumber,
        ReservationFacilityId: this.reservationNumber == 0 ? null : selectedUnitFacilityId,
        InquiryNumber: this.inquiryNumber == 0 ? null : this.inquiryNumber,
        InquiryFacilityId: this.inquiryNumber == 0 ? null : selectedUnitFacilityId,
        InquiryNotesFacilityId: null,
        FollowUpId: null,
        NotesDate: new Date(),
        Text: this.noteForm.value.CustomerNotes,
        CustomerNotes: true,
        PriorityNote: false,
        CollectionCall: false,
        PaymentReceiptId: null,
        DisplayAlert: isCallCenterGroup,
        UnitNo: selectedUnitNo,
        TransactionTypeId: this.transactionTypeId,
        Creator: null,
        PriorityId: 0,
        PriorityNoteExpiry: null,
        LinkedUnitLeaseNoList : this.mapLinkedUnitNotes(this.noteForm.value.LinkedUnitId),
        TenantId : this.unitsList[0].TenantId
      }
      this.saveNotesAPI(notesObj1)
    }
  }

  saveNotesAPI(notesObj) {
    this.prospectsService.SaveNotes(notesObj).subscribe((response: any) => {
      console.log(response);
      if (response.Success) {
        this.toaster.success('Notes Saved Successfully', 'Success', this.toasterConfig);
        this.noteForm.reset();
        this.FingerprintpopupComponent.resetFingerprintOrigin();
        this.isPriorityNotesSaved.emit(true);
      }
    });
  }

  disableNote() {
    return !this.noteForm.controls['LinkedUnitId'] || this.noteForm.controls['LinkedUnitId'].value == null || this.noteForm.controls['LinkedUnitId'].value.length ==  0 || !this.noteForm.controls['Notes'].value?.trim();
  }

  patchForm() {
    this.noteForm.patchValue({LinkedUnitId: [this.unitId]});
  }

  mapLinkedUnitNotes(likedUnitList) {
    return likedUnitList.map(unitId => {
      const customerDetails = this.unitsList.find(ele => unitId === ele.UnitId);
      return customerDetails ? {
        LeaseNo: customerDetails.LeaseNo,
        FacilityID: customerDetails.FacilityID
      } : null;
    }).filter(item => item);
  }
}
